import React from 'react';
import {
  Box,
  Button,
  IconButton,
  InputBase,
  Tooltip,
  Divider,
  useTheme,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';

function UserToolbar({ onSearch, searchQuery, onRefresh, onFilterClick, onColumnClick }) {
  const theme = useTheme();

  const iconButtonStyle = {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[50],
    border: `1px solid ${theme.palette.divider}`,
    minWidth: 'auto',
    padding: '4px',
    height: '30px',
    width: '30px',
    '&:hover': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {/* Search */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[50],
          borderRadius: theme.shape.borderRadius,
          px: 1.5,
          py: 0.5,
          maxWidth: 300,
          border: `1px solid ${theme.palette.divider}`,
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
            borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
          },
        }}
      >
        <SearchIcon
          sx={{
            fontSize: 20,
            color: theme.palette.text.secondary,
            mr: 1,
          }}
        />
        <InputBase
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          sx={{
            flex: 1,
            fontSize: theme.typography.body2.fontSize,
            color: theme.palette.text.primary,
            '&::placeholder': {
              color: theme.palette.text.secondary,
              opacity: 0.7,
            },
          }}
        />
      </Box>

      {/* View controls */}
      <Tooltip title="Filter list">
        <IconButton 
          size="small"
          onClick={onFilterClick}
          sx={iconButtonStyle}
        >
          <FilterListIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Choose columns">
        <IconButton
          size="small"
          onClick={onColumnClick}
          sx={iconButtonStyle}
        >
          <ViewColumnIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Divider orientation="vertical" flexItem sx={{ 
        borderColor: theme.palette.divider,
        opacity: theme.palette.mode === 'dark' ? 0.2 : 1 
      }} />

      {/* Actions */}
      <Tooltip title="Refresh">
        <IconButton 
          size="small"
          onClick={onRefresh}
          sx={iconButtonStyle}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default UserToolbar; 